<div *ngIf="items?.length" class="tab-links-container">
  <ng-container *ngFor="let item of items">
    <a
      *ngIf="item.routerLink"
      class="tab-link"
      [routerLink]="item.routerLink"
      [routerLinkActive]="'active'"
      (click)="onClick(item)"
    >
      {{ item.translationKey | translate }}
    </a>
    <a *ngIf="!item.routerLink" class="tab-link" [class.active]="item.isActive" (click)="onClick(item)">
      <img *ngIf="item.iconPath" class="icon" [src]="item.iconPath" alt="" />
      {{ item.translationKey | translate }}
      <span class="count" *ngIf="item.count > 0"> ({{ item.count }}) </span>
    </a>
  </ng-container>
</div>

<div *ngIf="!items?.length && showLoadingState" class="tab-links-container">
  <div
    *ngFor="let size of loadingItems$ | async"
    class="tab-link ghost-active-fluid"
    [style]="'width: ' + size + 'px'"
  ></div>
</div>
